import gql from "graphql-tag";
gql`
	query systemEvents(
		$where: SystemEventFilterInput
		$order: [SystemEventSortInput!]
		$skip: Int
		$take: Int
	) {
		systemEvents(where: $where, order: $order, skip: $skip, take: $take) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				createdOn
				duration
				serviceName
				details
				level
				levelInTree
				error
				hasChildren
				parentId
			}
		}
	}
`;
const SYSTEM_EVENTS_ONE_LEVEL = gql`
	query systemEventOneLevel(
		$parentId: UUID
		$where: SystemEventFilterInput
		$order: [SystemEventSortInput!]
		$skip: Int
		$take: Int
	) {
		systemEventOneLevel(
			parentId: $parentId
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				createdOn
				duration
				serviceName
				details
				level
				levelInTree
				error
				hasChildren
				parentId
				contact {
					name
				}
			}
		}
	}
`;
export {
  SYSTEM_EVENTS_ONE_LEVEL
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
